var exports = {
  "kL": "xcc377c0b--cb1a9c--container",
  "Ti": "xcc377c0b--cb1a9c--container-margin-top",
  "Sl": "xcc377c0b--cb1a9c--image",
  "R_": "xcc377c0b--cb1a9c--heading",
  "x6": "xcc377c0b--cb1a9c--button",
};

module.exports = exports;
